import React from "react";
import { string, func, bool } from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import {
  FormGroup,
  FormControl,
  FormLabel,
  Button,
  Alert,
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import ReactPasswordStrength from "react-password-strength";
import "!style-loader!css-loader!../LoginComponents/passwordStyles.css";

import { setNewPasswordPartners } from "../actions";

export class PartnersResetPasswordForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      newPasswordConfirm: "",
      setPasswordClicked: false,
      showPartnersPasswordError: false,
      validationStates: {
        newPassword: null,
        newPasswordConfirm: null,
        passwordsMatch: null,
      },
    };
  }

  /* ----------- React LifeCycle Methods ---------- */

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !this.props.showPartnersPasswordError &&
      this.props.showPartnersPasswordError !==
        nextProps.showPartnersPasswordError
    ) {
      this.setState({
        showPartnersPasswordError: true,
      });
    }
  }

  /* ----------- Validation Method ------------ */

  getValidationStates = () => {
    // Update validation states
    this.setState((prevState) => ({
      validationStates: {
        newPassword: prevState.newPasswordValid ? null : "error",
        newPasswordConfirm:
          prevState.newPassword === prevState.newPasswordConfirm
            ? null
            : "error",
        passwordsMatch: prevState.newPassword === prevState.newPasswordConfirm,
      },
    }));

    // Update setPasswordClicked
    if (
      this.state.newPassword !== this.state.newPasswordConfirm ||
      !this.state.newPasswordValid
    ) {
      this.setState({ setPasswordClicked: false });
    }
    return (
      this.state.newPassword === this.state.newPasswordConfirm &&
      this.state.newPasswordValid
    );
  };

  /* ----------- Event Handlers ------------- */

  handleInput = (event) => {
    const field = event.target.id;
    const { value } = event.target;

    this.setState({ [field]: value }, () => {
      if (
        (field === "emailAddress" &&
          this.state.validationStates.emailAddress === "error") ||
        (field === "password" &&
          this.state.validationStates.password === "error")
      ) {
        this.getValidationStates();
      }
    });
  };

  handlePasswordInput = (data) => {
    this.setState(
      { newPassword: data.password, newPasswordValid: data.isValid },
      () => {
        this.state.validationStates.newPassword = !data.isValid
          ? "error"
          : null;
      }
    );
  };

  handleSubmit = () => {
    this.setState({ setPasswordClicked: true });
    if (this.getValidationStates()) {
      this.props.onSetNewPasswordPartners(
        this.props.tk1,
        this.props.tk2,
        this.state.newPassword
      );
    }
  };

  handleKeyPress = (event) => {
    if (event.charCode === 13) {
      this.handleSubmit();
    }
  };

  handleRequestNewLink = () => {
    this.setState({ showPartnersPasswordError: false });
    this.props.showResetPasswordForm();
    this.props.dispatch(push("/partners"));
  };

  render() {
    // style variables
    const linkButtonStyle = {
      color: "#425cc7",
      textDecoration: "underline",
      backgroundColor: "none",
      border: "0",
      textAlign: "center",
      margin: 0,
      padding: 0,
    };

    return (
      <>
        <h1
          style={{
            fontSize: "28px",
            lineHeight: "1.5",
          }}
        >
          Enter your new password
        </h1>
        {this.state.validationStates.newPasswordConfirm !== null && (
          <div
            style={{
              borderRadius: "3px",
              backgroundColor: "#fbe8eb",
              color: "#e11f3b",
              minWidth: "100%",
              marginBottom: "10px",
              textAlign: "left",
              paddingLeft: "7px",
              paddingTop: "10px",
              paddingBottom: "10px",
              fontSize: "14px",
            }}
          >
            <FontAwesome name="exclamation-triangle" /> Your new password does
            not match your confirmation password
          </div>
        )}
        {this.state.showPartnersPasswordError ? (
          <Alert variant="danger">
            The link you used to set your password is no longer valid.
            <Button
              variant="default"
              className="btn-as-link"
              onClick={this.handleRequestNewLink}
            >
              Request a new link
            </Button>
          </Alert>
        ) : null}
        <FormGroup>
          <FormLabel className="mb-1">
            <strong>New Password</strong>
          </FormLabel>
          <ReactPasswordStrength
            minLength={8}
            inputProps={{ id: "newPassword" }}
            minScore={3}
            scoreWords={["weak", "okay", "good", "strong", "stronger"]}
            changeCallback={this.handlePasswordInput}
            style={{
              height: "34px",
              borderRadius: "4px",
              marginBottom: "5px",
              paddingRight: "10px",
            }}
            className={
              this.state.validationStates.newPassword !== null
                ? "add-error-border"
                : ""
            }
          />
          {this.state.validationStates.newPassword !== null ? (
            <p className="manual-override-invalid-feedback">
              Please enter a stronger password
            </p>
          ) : null}
        </FormGroup>
        <FormGroup>
          <FormLabel className="mb-1">
            <strong>Confirm New Password</strong>
          </FormLabel>
          <FormControl
            type="password"
            placeholder="Confirm your password"
            id="newPasswordConfirm"
            value={this.state.newPasswordConfirm}
            onChange={this.handleInput}
            onKeyPress={this.handleKeyPress}
            className={
              this.state.validationStates.newPasswordConfirm !== null
                ? "add-error-border"
                : ""
            }
          />
        </FormGroup>
        <div className="text-center">
          <Button
            variant="primary"
            size="lg"
            className="mt-3 mb-3"
            onClick={this.handleSubmit}
            id="setPassword"
            style={{ backgroundColor: "#425cc7", width: "100%" }}
            disabled={
              this.state.showPartnersPasswordError ||
              this.state.setPasswordClicked ||
              (this.state.newPassword === "" &&
                this.state.newPasswordConfirm === "")
            }
          >
            Set New Password
          </Button>
        </div>
        <div className="text-center">
          <button
            type="button"
            style={linkButtonStyle}
            onClick={this.props.showLoginForm}
            id="backToLogin"
          >
            Back to log in
          </button>
        </div>
      </>
    );
  }
}
PartnersResetPasswordForm.propTypes = {
  tk1: string.isRequired,
  tk2: string.isRequired,
  onSetNewPasswordPartners: func.isRequired,
  showLoginForm: func.isRequired,
  showPartnersPasswordError: bool,
  showResetPasswordForm: func.isRequired,
  dispatch: func,
};

const mapStateToProps = (state) => ({
  showPartnersPasswordError: state
    .get("App")
    .get("showPartnersNewPasswordErrorMessage"),
  locations: state.get("route").get("locationBeforeTransitions"),
});

function mapDispatchToProps(dispatch) {
  return {
    onSetNewPasswordPartners: (tk1, tk2, password) =>
      dispatch(setNewPasswordPartners(tk1, tk2, password)),
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnersResetPasswordForm);
